import React from 'react'

import { Avatar, Box, Icon, Line, Text } from '@factorialco/deprecated-design-system'

export type IllustrationType = 'check' | 'task-list-search'

interface InstalledSoftwareBlockProps {
  header: string
  subheader: string
  avatarLabel?: string
  icon?: IllustrationType
  bottomlineText?: React.ReactNode
}
const PageInfo = ({
  header,
  subheader,
  avatarLabel,
  icon,
  bottomlineText,
}: InstalledSoftwareBlockProps) => {
  return (
    <Box justifyContent="spaceAround" gap="s8">
      {icon && <Icon.Large icon={icon} />}
      {avatarLabel && <Avatar size="s64" label={avatarLabel} />}
      <Text.Header1>{header}</Text.Header1>
      <Text.Normal>{subheader}</Text.Normal>
      <Line />
      {bottomlineText && bottomlineText}
    </Box>
  )
}

export default PageInfo
